import { createApi } from '@reduxjs/toolkit/query/react';

import deserialize from '../helpers/getroPropertyMapper';
import { networkBaseQueryV2 } from './queries';

/**
 * Connection Paths (v2)
 * Fetches ranked paths connecting the current team to a target contact.
 */
export const connectionPathsV2Api = createApi({
  reducerPath: 'connectionPathsV2Api',
  baseQuery: networkBaseQueryV2,
  endpoints: (builder) => ({
    getConnectionPaths: builder.query({
      query: ({ contactId }) => ({
        url: `/contacts/${contactId}/connection_paths`,
      }),
      transformResponse: (response) => {
        if (!response?.data) return [];

        return deserialize(response);
      },
    }),
  }),
});

export const { useGetConnectionPathsQuery, useLazyGetConnectionPathsQuery } = connectionPathsV2Api;
